import { createClient } from '@supabase/supabase-js'

// Fallbacks del proyecto productivo. La anon key de Supabase se expone al cliente por diseño.
const DEFAULT_URL = 'https://rhpzwsnipweydsqkvlok.supabase.co'
const DEFAULT_ANON =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJocHp3c25pcHdleWRzcWt2bG9rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU0NTU2NTMsImV4cCI6MjA5MTAzMTY1M30.O_i_10zPPPh_ZIwX3gDfz0SdG0vjXnTiBQeGWzAvfYY'

const url = import.meta.env.VITE_SUPABASE_URL || DEFAULT_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY || DEFAULT_ANON

export const supabase = createClient(url, anon, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})
